module.exports = __webpack_public_path__ + "static/media/Nigel.26e55cee.png";